<template>
  <div class="search">
    <h2 class="icon"><i class="fa fa-television" aria-hidden="true"></i>Résultats pour "{{ $route.params.query }}"</h2>
    <div class="row auto-clear">
      <vimeo-videos
        :per_page="16"
        :query="$route.params.query"
      >
        <template slot-scope="props">
          <article class="col-lg-3 col-md-6 col-sm-4" v-for="video in props.videos">
            <single-video :video="video"></single-video>
          </article>
        </template>
      </vimeo-videos>
    </div>
    <div class="clearfix spacer"></div>
  </div>
</template>

<script>
  import { VimeoVideos } from 'itrnews-vuejs-api';
  import SingleVideo from './elements/Singlevideo';

  export default {
    name: 'Search',
    components: { VimeoVideos, SingleVideo },
  };
</script>



// WEBPACK FOOTER //
// src/components/Search.vue